import { $ValueModuleName, IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";

import { $VatInfoModuleName } from "./vatInfo.types";

type VatInfo = {
    countryCode: string;
    city: string;
    zipcode: string;
    street: string;
    number: string;
    box: string | null;
    companyName: string;
    valid: boolean;
    vatNr: string;
    vatNrPrefix: string;
};

const getVatInfoFor = (vatNr: string) => (state: IState) => {
    const data = getValueState(state, $VatInfoModuleName)?.data;
    if (data && data.vatNr === vatNr) {
        return data;
    }

    return null;
};

const isLoading = (state: IState) => {
    return !!getValueState(state, $VatInfoModuleName)?.isLoading;
};

export { getVatInfoFor, isLoading };
